import { Text } from '@chakra-ui/react';
import { TooltipComponentProps, TooltipTypeEnum } from '@components/map/tooltips/tooltip.types';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import {
  selectAutomatonSectionByName,
  selectSensorOrSubSensorConfigurationByUniqueKeys,
} from '@redux/situation/monitoring.selectors';
import { getSectionName } from '@utils/map/automatonSection.utils';

import { SensorUniqueKeys } from '@/types/map.types';
import { AutomatonSectionUniqueKeys } from '@/types/sensor/sensors';

function LabelTooltip({ data }: Readonly<TooltipComponentProps<TooltipTypeEnum.LABEL>>) {
  const config = useSelectorWithReplayMode(selectSensorOrSubSensorConfigurationByUniqueKeys, data as SensorUniqueKeys);
  const sectionData = useSelectorWithReplayMode(
    selectAutomatonSectionByName,
    (data as AutomatonSectionUniqueKeys).sectionName,
  );

  if (sectionData) {
    const sectionName = getSectionName(sectionData.section);
    return <Text textStyle="md">{sectionName}</Text>;
  }

  return <Text textStyle="md">{config?.name}</Text>;
}

export default LabelTooltip;
